import { SwiperOptions } from "swiper/types";
import { Pagination } from "swiper/modules";

export const SLIDER_SELECT_INJECT_TOKEN = "__slider_select__";

export const SWIPER_MAIN_SLIDER_OPTIONS: SwiperOptions = {
  pagination: {
    dynamicBullets: true,
    dynamicMainBullets: 4,
  },
  modules: [Pagination],
};
export const SWIPER_COVER_SLIDER_OPTIONS: SwiperOptions = {
  slidesPerView: "auto",
};
